export const CustomerSuccessMessages = {
  ACTIVATED: "Customer Activated Successfully",
  DEACTIVATED: "Customer Deactivated Successfully",
  TERMINATED: "Customer Terminated Successfully",
  SYNCED: "Customer Synced to Xero Successfully",
  UPDATED: "Customer Updated Successfully",
  PORTAL: "Customer Portal Access Updated Successfully",
  TABLE_UPDATED: "Customer Table Updated Successfully",
};

export enum CustomerType {
  CUSTOMER = "CUSTOMER",
  CUSTOMERUSER = "CUSTOMERUSER",
  DEACTIVATED_CUSTOMER = "DEACTIVATED_CUSTOMER",
  DEACTIVATED_CUSTOMERUSER = "DEACTIVATED_CUSTOMERUSER",
}

export enum CustomerStatus {
  ACTIVE = "ACTIVE",
  DEACTIVATED = "DEACTIVATED",
  TERMINATED = "TERMINATED",
  // SYNCED = "SYNCED",
}

export const CUSTOMER_USER_TABLE_CONSTANTS = {
  TITLE: {
    DEACTIVATED_CUSTOMER_USER: "Deactivated Customer User",
    CUSTOMER_USER: "Customer User",
  },
  EMPTY: {
    SUBTITLE: "Add a new customer user to the list.",
    BTN_LABEL: "Add Customer User",
  },
  FUNCTIONS: {
    SEARCH: "Search Customer User",
    ADD_BTN_LABEL: "Add New Customer's User",
  },
  FILTER: {
    LABEL: "User's Role",
  },
};

export enum CUSTOMER_USER_POSITION {
  ADMIN = "ADMIN",
  USER = "USER",
  CUSTOMER = "CUSTOMER",
}

export enum PROSPECT_TYPE {
  PROSPECT = "PROSPECT",
  PROSPECTUSER = "PROSPECTUSER",
}

export const PROSPECT_TOAST_MESSAGES = {
  PROSPECT_TRANSFER_SUCCESS: "Prospect Transfer to Customer Successfully",
};

export const CUSTOMER_USER_TOAST_MESSAGES = {
  CUSTOMER_USER_CREATED: "Customer User Created Successfully",
  CUSTOMER_USER_UPDATED: "Customer User Updated Successfully",
  CUSTOMER_USER_DELETED: "Customer User Deleted Successfully",
  TABLE_UPDATED: "Customer User Table Updated Successfully",
};

export const CustomerUserRoleTypeObject = [
  { label: "Admin", id: "ADMIN" },
  { label: "User", id: "USER" },
  { label: "Customer", id: "CUSTOMER" },
];

export const ProspectSuccessToastMessages = {
  PROSPECT_TABLE_UPDATED: "Prospect Table Updated Successfully",

  PROSPECT_USER_TABLE_UPDATED: "Prospect User Table Updated Successfully",
};
